import script from "./user.vue?vue&type=script&setup=true&lang=js"
export * from "./user.vue?vue&type=script&setup=true&lang=js"

import "./user.vue?vue&type=style&index=0&id=2850b741&lang=less"

const __exports__ = script;

export default __exports__